import * as actionType from "./constants";
import { USER_LOGOUT } from "../users/loggedUser/constants";
import { saveState } from "../containers/localStorage";
const messageInitialState = {
  socket: undefined,
  message: "",
  type: "",
  messages: [],
  indicate: false,
  messagesVisibility: {}
};
const message = (state = messageInitialState, action) => {
  switch (action.type) {
    case actionType.CLEAR_MESSAGE:
      return {
        ...state,
        message: "",
        type: ""
      };
    case actionType.SET_MESSAGE:
      return {
        ...state,
        message: action.payload.message,
        type: action.payload.type
      };

    case actionType.SET_INDICATE:
      return {
        ...state,
        indicate: false
      };

    case actionType.ADD_MESSAGE:
      return {
        ...state,
        messages: state.messages.concat([action.payload]),
        indicate: true
      };

    case actionType.TOGGLE_MESSAGE:
      const newMessagesVisibility = {
        ...state.messagesVisibility,
        [action.key]:
          state.messagesVisibility[action.key] === undefined
            ? false
            : !state.messagesVisibility[action.key]
      };
      console.log("change ", newMessagesVisibility);
      saveState("messagesVisibility", newMessagesVisibility);
      return {
        ...state,
        messagesVisibility: newMessagesVisibility
      };

    case actionType.SET_CONNECTION:
      return {
        ...state,
        socket: action.payload
      };
    case USER_LOGOUT:
      if (state.socket) state.socket.close();
      return {
        ...messageInitialState
      };
    default:
      return state;
  }
};

export default message;



// WEBPACK FOOTER //
// ./src/messages/reducer.js